import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import ObjectTypeStep from 'automation-ui-canvas/create/steps/ObjectTypeStep';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ManualTriggerStep(props) {
  return /*#__PURE__*/_jsx(ObjectTypeStep, Object.assign({}, props, {
    subHeading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "createWorkflow.manualEnrollmentSubHeader"
    })
  }));
}
export const manualTriggerStep = {
  component: ManualTriggerStep,
  getLabel: () => I18n.text('createWorkflow.step.eligibility')
};